// extracted by mini-css-extract-plugin
module.exports = {"container":"TextBanner_container__2alQt","content":"TextBanner_content__KP1fh","fade-in":"TextBanner_fade-in__1P2wn"};